import React, { useEffect, useRef } from 'react';
import { MapContainer, TileLayer, useMap, CircleMarker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet.heat';

// Evitar icono roto de Leaflet con webpack
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
});

// Capa con nombres de lugares (provincias, partidos, localidades) - Carto Voyager
const TILE_WITH_LABELS = 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png';
const ATTRIBUTION = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>';

function HeatLayer({ points }) {
  const map = useMap();
  const layerRef = useRef(null);

  const pointsKey = points && points.length ? JSON.stringify(points) : '';
  useEffect(() => {
    if (!map || !points || points.length === 0) return;
    if (layerRef.current) {
      map.removeLayer(layerRef.current);
      layerRef.current = null;
    }
    const heat = L.heatLayer(points, {
      radius: 50,
      blur: 30,
      maxZoom: 12,
      minOpacity: 0.35,
      gradient: { 0.2: '#43e97b', 0.5: '#fee140', 0.8: '#fa709a', 1: '#e65100' },
    });
    heat.addTo(map);
    layerRef.current = heat;
    return () => {
      if (layerRef.current) map.removeLayer(layerRef.current);
    };
  }, [map, pointsKey]);

  return null;
}

export default function MapaUbicacionHeatmap({ heatPoints, mapaPuntos = [], height = 400 }) {
  const center = [-38.4, -63.6];
  const zoom = 5;

  return (
    <div className="estadisticas-mapa-wrap" style={{ height, borderRadius: 8, overflow: 'hidden' }}>
      <MapContainer
        center={center}
        zoom={zoom}
        style={{ height: '100%', width: '100%', background: '#e8ecef' }}
        zoomControl={true}
      >
        <TileLayer url={TILE_WITH_LABELS} attribution={ATTRIBUTION} />
        {heatPoints && heatPoints.length > 0 && <HeatLayer points={heatPoints} />}
        {mapaPuntos.map((p, i) => (
          <CircleMarker
            key={i}
            center={[p.lat, p.lng]}
            radius={8}
            pathOptions={{ fillColor: '#e65100', color: '#bf360c', weight: 1, opacity: 0.9, fillOpacity: 0.4 }}
          >
            <Popup>
              <div className="estadisticas-mapa-popup">
                {p.provincia && p.provincia !== '—' && <div><strong>Provincia:</strong> {p.provincia}</div>}
                {p.partido && p.partido !== '—' && <div><strong>Partido:</strong> {p.partido}</div>}
                {p.barrio && p.barrio !== '—' && <div><strong>Barrio:</strong> {p.barrio}</div>}
                <div><strong>Inscriptos:</strong> {p.cantidad}</div>
              </div>
            </Popup>
          </CircleMarker>
        ))}
      </MapContainer>
    </div>
  );
}
